import { render, staticRenderFns } from "./WorkDataTable.vue?vue&type=template&id=66a65694&scoped=true"
import script from "./WorkDataTable.vue?vue&type=script&lang=js"
export * from "./WorkDataTable.vue?vue&type=script&lang=js"
import style0 from "./WorkDataTable.vue?vue&type=style&index=0&id=66a65694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a65694",
  null
  
)

export default component.exports